import { messages } from "../lib/messages";
import { FullScreenMessage } from "./FullScreenMessage";

/** InvalidLinkScreen — путь не содержит /s/<slug>: ссылка открыта неверно. */
export function InvalidLinkScreen() {
  return (
    <FullScreenMessage testId="shop-invalid-link" title={messages.invalidLink} description={messages.invalidLinkHint} />
  );
}
